<template>
  <div class="collector-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('device.group.Return_to_group_list')}}</Button>
    <Card class="edit-card">
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" :label-width="100">
            <i-Col span="8">
              <FormItem :label="$t('device.group.name')">
                <Input class="info" v-model="name" :placeholder="$t('device.group.please_enter')"></Input>
              </FormItem>
              <FormItem >
                <Input class="info" v-model="search" :placeholder="$t('device.group.name')">
                   <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
                   <Button slot="append" icon="refresh" @click="handleReset()"></Button>
                </Input>
              </FormItem>
            </i-Col>
            <i-Col span="8">
              <FormItem :label="$t('device.group.remark')">
                <Input class="info" v-model="remark" :placeholder="$t('device.group.please_enter')"></Input>
              </FormItem>
              <FormItem><a style="font-size: 30px; color: black;">{{$t('device.group.chosen')}}{{sum}}{{$t('device.group.devices')}}</a></FormItem>
            </i-Col>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <FormItem >
                <Table height="590" width="600" class="collector-table" border ref="selection" :columns="columns" :data="collectors" style="height: 500px;" @on-selection-change="collectorSelect" ></Table>
              </FormItem>
            <!-- <FormItem label="收集器">
              <CheckboxGroup v-model="collectors">
                <Checkbox v-for="item in collectorList" :label="item.id" :key="item.id">{{item.name}}</Checkbox>
              </CheckboxGroup>
            </FormItem> -->
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t('device.group.save')}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'RouterEdit',
  data () {
    return {
      id: 0,
      name: '',
      sum: 0,
      collectors: [],
      remark: '',
      collectorList: [],
      search: '',
      selection: [],
      checked: [],
      routers: [],
      columns: [
        { type: 'selection', width: 60 },
        { title: this.$t('device.group.name'), key: 'name', sortable: true, sortType: 'asc' },
        { title: this.$t('device.group.width'), key: 'width', sortable: true, width: 100 },
        { title: this.$t('device.group.router'), key: 'RouterName', sortable: true }
        // { title: '宽度', key: 'width' }
      ]
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('device.group.New_group') : this.$t('device.group.edit_group')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let d = []
      for (let i = 0; i < this.selection.length; i++) {
        d[i] = this.selection[i].id
      }
      let group = {
        id: this.id,
        name: this.name,
        collectors: d,
        remark: this.remark
      }
      Api.collectorGroup.save(group).then(() => {
        this.$router.push({'name': 'CollectorGroup'})
      })
    },
    handleSearch () {
      this.collectors = []
      for (let i = 0; i < this.collectorList.length; i++) {
        let p = this.collectorList[i]
        if (p.name.indexOf(this.search) !== -1) {
          this.collectors.push(p)
        }
      }
    },
    handleReset () {
      this.collectors = this.collectorList
    },
    collectorSelect (s) {
      this.selection = s
      this.sum = this.selection.length
    }
  },
  mounted () {
    Api.router.list().then(res => {
      this.routers = res.routers
    })
    Api.collector.list().then(res => {
      this.collectorList = res.collectors
      this.collectors = res.collectors
      for (let i = 0; i < this.collectors.length; i++) {
        for (let j = 0; j < this.checked.length; j++) {
          if (this.checked[j] === this.collectors[i].id) {
            this.collectors[i]._checked = true
            this.sum++
          }
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.collectorGroup.get(id).then(res => {
        let g = res.collectorGroup
        next(vm => {
          vm.id = g.id
          vm.name = g.name
          vm.checked = g.collectors
          vm.remark = g.remark
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .collector-edit-page {
    padding: 10px;
    /* height: 500px; */
  }
  .edit-card {
    margin-top: 20px;
    /* height: 500px; */
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  /* .edit-form .info{
    width: 33.33333%
  }
  .edit-form .collector-table{
    width: 33.33333%
  }
  .edit-form .text{
    width: 33.33333%
  } */
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?324479ff